import styled from "styled-components";

const Main = styled.main`
    margin: 92px 18px;
` 

export default Main;